import * as actionTypes from "./actionTypes";
import format from "date-fns/format";
import moment from "moment";

import api from "../../services";
import { apiStart, apiSuccess } from "./apiActions";
import { errorHandler, catchHandler, successHandler } from "./responseHandler";

import { convertHours, parseTime, setPatients } from "./dashboardActions";
import { getUserData } from "../../utils/localStorage";

import constants from "../../constants";
import {
  parseDateToLocal,
  parseTimeToLocal,
  getMeridiem,
  parseDateToLocalWithTime,
} from "../../utils/parseDateTime";
import messages from "../../constants/messages";
import { uploadFileToS3 } from "./physicianOnboardingActions";
import { setOngoingAppointmentData } from "./ongoingAppointmentActions";
import { object } from "prop-types";

export const setRequestsAppointments = payload => {
  return dispatch =>
    dispatch({
      type: actionTypes.SET_REQUESTS_APPOINTMENTS,
      payload,
    });
};

export const setAppointmentData = payload => {
  return dispatch =>
    dispatch({
      type: actionTypes.SET_APPOINTMENT_DATA,
      payload,
    });
};

export const removeAppointment = appointmentObj => {
  return dispatch =>
    dispatch({
      type: actionTypes.REMOVE_APPOINTMENT_DATA,
      payload: {
        appointmentObj,
      },
    });
};

export const resetAppointmentData = () => {
  return dispatch =>
    dispatch({
      type: actionTypes.RESET_REQUESTED_APPOINTMENT,
    });
};

const pushToArray = (objArray, obj) => {
  var index = objArray.findIndex(arr => arr.id === obj.id);

  if (index === -1) {
    objArray.push(obj);
  } else {
    objArray[index] = obj;
  }
  return objArray;
};

export const getAppointments =  (status,page = 1, date) => {
  return (dispatch, getState) => {
    const current_date = format(new Date(), "yyyy-MM-dd");
    
   
    const payload = {
      doctor_detail: getUserData()?.id,
      status: status,
      appointment_date: date,
      current_date,
      patient_id: getState()?.dashboard?.patients?.patient?.id,
    };
  
    const stateAppointments = getState()?.dashboard?.appointments;
    let existingRequestedAppointments = stateAppointments?.requests;
    let exisitingCompletedAppointments = stateAppointments?.completed;
    
    dispatch(apiStart());
    (!date
      ? api.getAppointmentList(page, payload)
      : api.getDateWiseAppointmentList(page, payload)
    )
    
      .then(response => {
        const res = response.data;
        if (res.status_code === 200) {
          let appointments = res.data[0].results;
        
          const total_pages = res.data[0]?.links?.total_pages;
          const scheduled = {};

          let noOfRequestedAppointments = 0;
          let noOfScheduledAppointments = 0;
          let noOfCompletedAppointments = 0;
          let value=[];
          var appointmentOnDate= appointments.filter(function (el)
          {
            return el.appointment_date===date
          }
          );
          noOfScheduledAppointments=appointmentOnDate.length
          appointments.forEach(appointment => {
          
            
            let appointment_date, slot_time;
            let startTime;
            let endTime;
            if (appointment.hasOwnProperty("is_visit_now")) {
              appointment_date = format(
                new Date(appointment?.requested_at),
                "yyyy-MM-dd"
              );
              slot_time = format(new Date(appointment?.requested_at), "HH:mm");
              startTime = slot_time;
            } else {
              appointment_date = appointment.appointment_date;
              slot_time = appointment.slot_time;
              startTime = parseTimeToLocal(slot_time, appointment_date);
            }

            const slt_hour = parseInt(startTime.split(":")[0]);
            const slt_min = parseInt(startTime.split(":")[1]);

            if (appointment.hasOwnProperty("duration")) {
              endTime = convertHours(
                parseTime(slt_hour, slt_min) + appointment.duration
              );
            }

            const apt = {
              id: appointment.id,
              startTime,
              endTime,
              sTMeridiem: getMeridiem(startTime),
              eTMeridiem: endTime ? getMeridiem(endTime) : null,
              topic: appointment.topic,
              patient_detail: appointment.patient_detail,
              appointmentDate: appointment.hasOwnProperty("is_visit_now")
                ? parseDateToLocalWithTime(slot_time, appointment_date)
                : parseDateToLocalWithTime(
                    slot_time,
                    appointment.appointment_date
                  ),
              status: appointment.status
                ? appointment.status
                : appointment.doctor_status,
              page: page,
              patientName:
                appointment.patient_detail.first_name +
                " " +
                appointment.patient_detail.last_name,
              guest_doctor_status: appointment?.guest_doctor_status,
              guest_doctor_id: appointment?.guest_doctor?.id,
              doctor_detail: appointment?.doctor_detail,
              guest_doctor: appointment?.guest_doctor,
              parent_details: appointment?.parent_details,
              is_dependent_invited: appointment?.is_dependent_invited,
              patient_dosespot_id:
                appointment?.patient_detail?.dosespot_id || "17054716",
              chat_ids: appointment?.chat_details,
              created_at: appointment?.created_at,
              created_by: appointment?.created_by,
              updated_at: appointment?.updated_at,
              is_visit_now: appointment?.is_visit_now
                ? appointment?.is_visit_now
                : false,
              is_joined:appointment?.is_joined,
              is_subscribed_patient: appointment?.is_subscribed_patient

            };

            let date;
            if (
              (appointment?.guest_doctor_status &&
                appointment?.guest_doctor_status === "REQUESTED" &&
                appointment?.guest_doctor?.id === getUserData()?.id &&
                appointment.status === "ACCEPTED") ||
              ((appointment.status === "REQUESTED" ||
                appointment.status === "RESCHEDULE_REQUEST") &&
                appointment?.guest_doctor?.id !== getUserData()?.id)
            ) {
              noOfRequestedAppointments++;
              date = parseDateToLocalWithTime(
                appointment.slot_time,
                appointment.appointment_date
              );
              if (date in existingRequestedAppointments) {
                existingRequestedAppointments[date] = pushToArray(
                  [...existingRequestedAppointments[date]],
                  apt
                );
              } else {
                existingRequestedAppointments[date] = [apt];
              }
            }

            if (
              (appointment?.guest_doctor_status &&
                (appointment?.guest_doctor_status === "ACCEPTED" )||(appointment?.guest_doctor_status === "COMPLETED")
                |(appointment?.guest_doctor_status === "CANCELLED")|(appointment?.guest_doctor_status === "NO_SHOW")&&
                appointment?.guest_doctor?.id === getUserData()?.id) ||
              (appointment?.guest_doctor?.id !== getUserData()?.id &&
                (appointment.status === "ACCEPTED") ||(appointment.status ==="COMPLETED")|
                (appointment.status ==="CANCELLED")||(appointment.status ==="NO_SHOW"))
            ) {
              if (appointment.appointment_count)
                noOfScheduledAppointments =appointmentOnDate.length;
              date = parseDateToLocalWithTime(
                appointment.slot_time,
                appointment.appointment_date
              );
            
              if (date in scheduled) {
                scheduled[date].push(apt);
              } else {
                scheduled[date] = [apt];
              }
            }

            if (
              (appointment?.guest_doctor_status &&
                appointment?.guest_doctor_status === "COMPLETED" &&
                appointment?.guest_doctor?.id === getUserData()?.id) ||
              (appointment?.guest_doctor?.id !== getUserData()?.id &&
                appointment.status === "COMPLETED") ||
              (appointment?.guest_doctor_status &&
                appointment?.guest_doctor_status === "COMPLETED" &&
                appointment?.guest_doctor?.id === getUserData()?.id) ||
              (appointment?.guest_doctor?.id !== getUserData()?.id &&
                appointment.doctor_status === "COMPLETED")
            ) {
              noOfCompletedAppointments++;
              date = appointment_date;
              if (date in exisitingCompletedAppointments) {
                exisitingCompletedAppointments[date] = pushToArray(
                  [...exisitingCompletedAppointments[date]],
                  apt
                );
              } else {
                exisitingCompletedAppointments[date] = [apt];
              }
            }
          });

          let groupByDateSchedule = {};
          let sortedScheduled = {};
          status.includes("COMPLETED") |status.includes("ACCEPTED") |status.includes("CANCELLED")|status.includes("NO_SHOW") &&
            (groupByDateSchedule = Object.keys(scheduled).sort(function (a, b) {
              return a
                .split("-")
                .reverse()
                .join("")
                .localeCompare(b.split("-").reverse().join(""));
            })) &&
            groupByDateSchedule.map(
              sch =>
                (sortedScheduled[sch] = scheduled[sch].sort((a, b) =>
                  parseInt(a?.startTime?.split(":")[0]) >
                    parseInt(b?.startTime?.split(":")[0]) ||
                  (parseInt(a?.startTime?.split(":")[0]) ===
                    parseInt(b?.startTime?.split(":")[0]) &&
                    parseInt(a?.startTime?.split(":")[1]) >
                      parseInt(b?.startTime?.split(":")[1]))
                    ? 1
                    : -1
                ))
            );
          dispatch(
            setAppointmentData(
              status.includes("REQUESTED")
                ? {
                    requests: existingRequestedAppointments,
                    noOfRequestedAppointments,
                    totalPages: total_pages,
                  }
                : {
                    scheduled: sortedScheduled,
                    noOfScheduledAppointments,
                    schAppointmentDetail:sortedScheduled?.[date]?.[0],
                    scheduledAppointments:Object.keys(sortedScheduled),
                    completed: exisitingCompletedAppointments,
                    totalPages: total_pages,
                    noOfCompletedAppointments,
                    appointments
                  }
            )
          );
        } else {
          errorHandler(res.message[0]);
        }
        dispatch(apiSuccess());
      })
      .catch(error => {
        catchHandler(error, dispatch);
      });
  };
};

export const updateAppointmentStatus = (appointmentId, status, cb) => {
  return (dispatch, getState) => {
    let appointmentObj = {};
    let isExpired = false;

    if (status === "ACCEPTED") {
      const appointments = getState()?.dashboard?.appointments;
      const requestedAppointments = appointments?.requests;

      (appointments?.appointmentDetail?.id === appointmentId &&
        (appointmentObj = appointments?.appointmentDetail)) ||
        Object.keys(requestedAppointments).filter(req =>
          requestedAppointments[req].find(
            reqApt => reqApt.id === appointmentId && (appointmentObj = reqApt)
          )
        );

      const appointmentDate = new Date(
        appointmentObj.appointmentDate + " " + appointmentObj.startTime
      );

      isExpired = appointmentDate.getTime() < new Date().getTime();
    }

    if (!isExpired) {
      const payload = {
        status,
        doctor_timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      };

      dispatch(apiStart());
      api
        .updateAppointmentStatus(appointmentId, payload)
        .then(response => {
          const res = response.data;
          if (res.status_code === 200) {
            const status = constants.APPOINTMENT_STATUS;
            let message = "";
            switch (res?.data?.status) {
              case status.accepted:
                message = "has been accepted";
                break;
              case status.denied:
                message = "has been denied";
                break;
              case status.rescheduleRequest:
                message = "has been requested for rescheduling";
                break;
              case status.cancelled:
                message = "has been canceled";
                break;
              default:
                message = "";
            }
            successHandler(`Appointment ${message}`);
            cb();
          } else {
            errorHandler(res.message[0]);
          }
          dispatch(apiSuccess());
        })
        .catch(error => {
          catchHandler(error, dispatch);
        });
    } else {
      errorHandler(messages.APPOINTMENT_EXPIRED);
    }
  };
};

export const getAppointmentDetail = appointmentId => {
  return (dispatch, getState) => {
    dispatch(apiStart());

    api
      .getAppointmentDetail(appointmentId)
      .then(response => {
        const res = response.data;
        if (res.status_code === 200) {
          const appointment = res.data[0][0];

          let patients =
            (getState()?.dashboard?.patients?.patients?.length > 0 &&
              getState()?.dashboard?.patients?.patients) ||
            [];

          const startTime = parseTimeToLocal(
            appointment?.slot_time,
            appointment.appointment_date
          );

          const slt_hour = parseInt(startTime.split(":")[0]);
          const slt_min = parseInt(startTime.split(":")[1]);

          const endTime = convertHours(
            parseTime(slt_hour, slt_min) + appointment.duration
          );

          patients = pushToArray([...patients], appointment.patient_detail);

          const apt = {
            id: appointment.id,
            startTime,
            endTime,
            sTMeridiem: getMeridiem(startTime),
            eTMeridiem: getMeridiem(endTime),
            topic: appointment.topic,
            patient_detail: appointment.patient_detail,
            appointmentDate: parseDateToLocalWithTime(
              appointment.slot_time,
              appointment.appointment_date
            ),
            status: appointment.status,
            patientName:
              appointment.patient_detail.first_name +
              " " +
              appointment.patient_detail.last_name,
            guest_doctor_status: appointment?.guest_doctor_status,
            guest_doctor_id: appointment?.guest_doctor?.id,
            doctor_detail: appointment?.doctor_detail,
            guest_doctor: appointment?.guest_doctor,
            parent_details: appointment?.parent_details,
            is_dependent_invited: appointment?.is_dependent_invited,
            is_joined:appointment?.is_joined
          };

          dispatch(
            setAppointmentData({
              appointmentDetail: apt,
            })
          );

          dispatch(
            setPatients({
              patients,
            })
          );
        } else {
          dispatch({
            type: actionTypes.RESET_APPOINTMENT_DETAIL,
          });
          errorHandler(res.message[0]);
        }
        dispatch(apiSuccess());
      })
      .catch(error => {
        catchHandler(error, dispatch);
      });
  };
};

export const emptyPatientList = currentTab => {
  return dispatch => {
    const allPatientsPayload = {
      type: actionTypes.EMPTY_PATIENT_LIST,
      allPatients: [],
    };

    const myPatientsPayload = {
      type: actionTypes.EMPTY_PATIENT_LIST,
      myPatients: [],
    };

    dispatch(
      currentTab === "allPatients" ? allPatientsPayload : myPatientsPayload
    );
  };
};

export const getAllPatientList = (
  page = 1,
  searchPatient = "",
  searchValue
) => {
  return (dispatch, getState) => {
    dispatch(apiStart());

    const allPatients = getState()?.dashboard?.patients?.allPatients;

    api
      .getAllPatientList(getUserData().id, page, searchPatient, searchValue)
      .then(response => {
        const res = response.data;
        if (res.status_code === 200) {
          const resp = res.data[0];
          const data =
            page > 1 ? [...allPatients, ...resp.results] : resp.results;

          dispatch(
            setPatients({
              allPatients: data,
              totalPatientPages: resp.links.total_pages,
            })
          );
        } else {
          errorHandler(res.message[0]);
        }
        dispatch(apiSuccess());
      })
      .catch(error => {
        catchHandler(error, dispatch);
      });
  };
};

export const getDoctorPatientList = (page = 1, searchPatient = "") => {
  return (dispatch, getState) => {
    dispatch(apiStart());
    const myPatients = getState()?.dashboard?.patients?.myPatients;

    api
      .getDoctorPatientList(getUserData().id, page, searchPatient)
      .then(response => {
        const res = response.data;
        if (res.status_code === 200) {
          const resp = res.data[0];
          const data =
            page > 1 ? [...myPatients, ...resp.results] : resp.results;

          dispatch(
            setPatients({
              myPatients: data,
              totalPatientPages: resp.links.total_pages,
            })
          );
        } else {
          errorHandler(res.message[0]);
        }
        dispatch(apiSuccess());
      })
      .catch(error => {
        catchHandler(error, dispatch);
      });
  };
};

export const getPatient = id => {
  return (dispatch, getState) => {
    dispatch(apiStart());

    api
      .getPaitentInfo(id)
      .then(response => {
        const res = response.data;
        if (res.status_code === 200) {
          const data = res?.data[0][0];

          dispatch({
            type: actionTypes.SET_PATIENT_PROFILE,
            payload: data,
          });
        } else {
          errorHandler(res.message[0]);
        }
        dispatch(apiSuccess());
      })
      .catch(error => {
        catchHandler(error, dispatch);
      });
  };
};

const checkTime = appointmentData => {
  let currentStartDate = moment();

  let currentEndDate = moment();
  currentEndDate.seconds(0).milliseconds(0);

  let startTime = appointmentData.startTime;
  const splitStartTime = startTime.split(/:/);
  let startTimeDay = moment();
  startTimeDay
    .hours(parseInt(splitStartTime[0]))
    .minutes(parseInt(splitStartTime[1]))
    .seconds(0)
    .milliseconds(0);

  let endTime = appointmentData.endTime;
  const splitEndTime = endTime.split(/:/);
  let endTimeDay = moment();
  endTimeDay
    .hours(parseInt(splitEndTime[0]))
    .minutes(parseInt(splitEndTime[1]))
    .seconds(0)
    .milliseconds(0);

  if (
    moment(parseDateToLocal(appointmentData.appointmentDate)).format(
      "YYYY-MM-DD"
    ) === moment().format("YYYY-MM-DD")
  ) {
    if (
      currentStartDate.add(10, "minutes").toDate().getTime() >=
      startTimeDay.toDate().getTime()
    )
      if (
        currentEndDate.seconds(0).milliseconds(0).toDate().getTime() <=
        endTimeDay.toDate().getTime()
      ) {
        return true;
      } else {
        errorHandler(messages.APPOINTMENT_TIME_EXPIRED);
        return false;
      }
    else {
      errorHandler(messages.APPOINTMENT_START_CALL);
      return false;
    }
  } else {
    errorHandler(messages.APPOINTMENT_START_CALL);
    return false;
  }
};

export const appointmentSessionCreation = (
  appointmentId,
  type,
  isTimeCheck = true,
  cb = () => {}
) => {
  return (dispatch, getState) => {
    dispatch(apiStart());

    const appointmentData =
      type === "appointment"
        ? getState()?.dashboard?.appointments?.schAppointmentDetail
        : getState()?.dashboard?.appointments?.visitNow;
    const payload = {
      [type]: appointmentId,
    };

    let checkCondition = true;

    if (isTimeCheck) {
      checkCondition = checkTime(appointmentData);
    }

    if (checkCondition) {
      api
        .appointmentSessionCreation(payload)
        .then(response => {
          const res = response.data;
          if (res.status_code === 200) {
            const resData = res?.data;

            const token = resData?.token;
            const sessionId = resData?.session_id;

            localStorage.setItem("opentok_token", token);
            localStorage.setItem("opentok_session_id", sessionId);

            dispatch(
              setOngoingAppointmentData({ currentAppointment: appointmentData })
            );

            cb();
          } else {
            errorHandler(res.message[0]);
          }
          dispatch(apiSuccess());
        })
        .catch(error => {
          catchHandler(error, dispatch);
        });
    } else {
      dispatch(apiSuccess());
    }
  };
};

export const uploadScreenshot = (imgData, fileName, cb) => {
  const urls = imgData;
  const retrunUrls = [];
  urls.forEach(url =>
    fetch(url)
      .then(res => res.blob())
      .then(blob => {
        const file = new File([blob], fileName, { type: "image/png" });
        const uploadScreenshot = uploadFileToS3(file);

        uploadScreenshot
          .then(fileUrl => {
            retrunUrls.push(fileUrl.location);
            if (retrunUrls.length === imgData.length) {
              cb(
                new Promise((resolve, reject) => {
                  resolve(retrunUrls);
                })
              );
            }
          })
          .catch(err => {
            console.log(err);
            catchHandler("Screenshot upload failed");
          });
      })
  );
};

export const updateAvailablePermission = (is_available, cb) => {
  return (dispatch, getState) => {
    const payload = {
      is_available: is_available,
    };
    dispatch(apiStart());
    api
      .updateAvailablePermission(getUserData().id, payload)
      .then(response => {
        const res = response.data;
        if (res.status_code === 200) {
          const currentAppointments = getState()?.dashboard?.appointments || {};
          dispatch(
            setAppointmentData({
              ...currentAppointments,
              is_available: is_available,
            })
          );
        } else {
          errorHandler(res.message[0]);
        }
        dispatch(apiSuccess());
      })
      .catch(error => {
        catchHandler(error, dispatch);
      });
  };
};

export const updateAvailablePermissionOnly = (is_available, cb) => {
  return (dispatch, getState) => {
    const payload = {
      is_available: is_available,
    };
    dispatch(apiStart());
    api
      .updateAvailablePermission(getUserData().id, payload)
      .then(response => {
        const res = response.data;
        if (res.status_code === 200) {
        } else {
          errorHandler(res.message[0]);
        }
        dispatch(apiSuccess());
      })
      .catch(error => {
        catchHandler(error, dispatch);
      });
  };
};

export const setVisitNowData = payload => {
  return (dispatch, getState) => {
    const currentAppointments = getState()?.dashboard?.appointments || {};
    dispatch({
      type: actionTypes.SET_VISIT_NOW,
      payload: {
        ...currentAppointments,
        visitNow: payload
      },
    });
  };
};

export const getVisitNowAppointment = () => {
  return (dispatch, getState) => {
    dispatch(apiStart());

    // Check if there's a test appointment - don't overwrite it
    const currentVisitNow = getState()?.dashboard?.appointments?.visitNow;
    if (currentVisitNow?.id === 'test-123') {
      console.log('🧪 Preserving test visitNow appointment');
      dispatch(apiSuccess());
      return;
    }

    api
      .getVisitNowRequest(getUserData()?.id)
      .then(response => {
        const res = response.data;
        if (res.status_code === 200 && res.data?.length > 0) {
          const appointmentData = res.data[0];

          let patients =
            (getState()?.dashboard?.patients?.allPatients?.length > 0 &&
              getState()?.dashboard?.patients?.allPatients) ||
            [];
          patients = pushToArray([...patients], appointmentData?.patient);

          dispatch(
            setPatients({
              allPatients: patients,
            })
          );

          const appointmentObj = {
            ...appointmentData,
            patient_dosespot_id:
              appointmentData?.patient?.dosespot_id || "17054716",
          };

          dispatch(setVisitNowData(appointmentObj));
        } else {
          dispatch(setVisitNowData({}));
        }
        dispatch(apiSuccess());
      })
      .catch(error => {
        catchHandler(error, dispatch);
      });
  };
};

export const getAvailablePermission = () => {
  return (dispatch, getState) => {
    dispatch(apiStart());
    api.getAvailablePermission(getUserData().id).then(response => {
      const res = response.data.data;
      if (res.length > 0) {
        if (res) {
          const detailsObj = res[0];
          const currentAppointments = getState()?.dashboard?.appointments || {};
          dispatch(
            setAppointmentData({
              ...currentAppointments,
              is_available: detailsObj.is_available,
            })
          );
        } else {
          errorHandler(res.message[0]);
        }
        dispatch(apiSuccess());
      }
    });
  };
};

export const updateVisitNowRequestStatus = (
  appointmentId,
  status,
  value = false,
  cb = () => {}
) => {
  return (dispatch, getState) => {
    dispatch(apiStart());

    const visitNow = getState()?.dashboard.appointments?.visitNow;

    let doctor_status = status,
      guest_doctor_status = status;

    if (status !== "COMPLETED") {
      if (visitNow?.doctor?.id === getUserData()?.id) {
        doctor_status = status;
        guest_doctor_status = null;
      } else if (visitNow?.guest_doctor?.id === getUserData()?.id) {
        doctor_status = visitNow?.doctor_status;
        guest_doctor_status = status;
      }
    }

    if (status == "COMPLETED") {
      if (visitNow?.doctor?.id === getUserData()?.id) {
        doctor_status = status;
        guest_doctor_status = status;
      } else if (visitNow?.guest_doctor?.id === getUserData()?.id) {
        doctor_status = visitNow?.doctor_status;
        guest_doctor_status = status;
      }
    }

    const payload = {
      guest_doctor_status: guest_doctor_status,
      doctor_status: doctor_status,
      isRejoined: value,
    };

    api
      .updateVisitNowRequestStatus(appointmentId, payload)
      .then(response => {
        const res = response.data;
        if (res.status_code === 200) {
          status === "ACCEPTED"
            ? dispatch(
                appointmentSessionCreation(
                  res?.data?.appointment || res?.data?.id,
                  "visit_now",
                  false,
                  cb
                )
              )
            : dispatch(getVisitNowAppointment());

          dispatch(
            setAppointmentData({
              visitNow: getState()?.dashboard?.appointments?.visitNow,
            })
          );

          status === "COMPLETED" &&
            dispatch(
              setOngoingAppointmentData({
                completedVisitNow:
                  getState()?.dashboard?.appointments?.visitNow,
              })
            );

          dispatch(
            setOngoingAppointmentData({
              visitNow: getState()?.dashboard?.appointments?.visitNow,
            })
          );

          // status === "COMPLETED" &&
          //   successHandler("You paid $14 successfully to UrgiDoctor");

          status === "DENIED" &&
            successHandler(messages.VISIT_NOW_REQUEST_DENIED);
          status !== "ACCEPTED" && cb();
        }
        dispatch(apiSuccess());
      })
      .catch(error => {
        catchHandler(error, dispatch);
      });
  };
};

export const getSessionDetailsForPatient = (appointmentId, cb = () => {}) => {
  return (dispatch, getState) => {
    const payload = {
      appointment: appointmentId,
    };
    dispatch(apiStart());

    api
      .getSessionDetailsForPatient(payload)
      .then(response => {
        const res = response.data;
        if (res.status_code === 200) {
          const resData = res?.data;

          const token = resData?.token;
          const sessionId = resData?.session_id;

          localStorage.setItem("opentok_token", token);
          localStorage.setItem("opentok_session_id", sessionId);

          cb();
        } else {
          errorHandler(res.message[0]);
        }
        dispatch(apiSuccess());
      })
      .catch(error => {
        catchHandler(error, dispatch);
      });
  };
};

export const updateAppointmentCompletedStatus = appointmentId => {
  return (dispatch, getState) => {
    dispatch(apiStart());

    const status = {
      status: "COMPLETED",
      guest_doctor_status: "COMPLETED",
    };

    api
      .updateAppointmentCompletedStatus(appointmentId, status)
      .then(response => {
        const res = response.data;
        if (res.status_code === 200) {
          // successHandler("You paid $14.99 successfully to UrgiDoctor");
        } else {
          errorHandler(res.message[0]);
        }
        dispatch(apiSuccess());
      })
      .catch(error => {
        catchHandler(error, dispatch);
      });
  };
};

export const reviewChartNotification = (appointmentId, cb = () => {}) => {
  return (dispatch, getState) => {
    dispatch(apiStart());

    api
      .reviewChartNotification(appointmentId)
      .then(response => {
        const res = response.data;
        if (res.status_code === 200) {
          cb();
        } else {
          errorHandler(res.message[0]);
        }
        dispatch(apiSuccess());
      })
      .catch(error => {
        catchHandler(error, dispatch);
      });
  };
};

export const placeHoldOnCard = (
  appointmentId,
  appointmentType,
  cb = () => {}
) => {
  return (dispatch, getState) => {
    dispatch(apiStart());

    const appointmentData =
      appointmentType === "VISIT_NOW"
        ? getState()?.dashboard?.appointments?.visitNow
        : getState()?.dashboard?.appointments?.schAppointmentDetail;

    const payload =
      appointmentType === "VISIT_NOW"
        ? {
            details_id:
              appointmentData?.patient_detail?.id ||
              appointmentData?.patient?.id,
            amount:
              parseInt(appointmentData?.doctor_detail?.fees) ||
              parseInt(appointmentData?.doctor?.fees),
            currency: "usd",
            visit_now_id: appointmentId,
            category: appointmentType,
          }
        : {
            details_id:
              appointmentData?.patient_detail?.id ||
              appointmentData?.patient?.id,
            amount:
              parseInt(appointmentData?.doctor_detail?.fees) ||
              parseInt(appointmentData?.doctor?.fees),
            currency: "usd",
            appointment_id: appointmentId,
            category: appointmentType,
          };

    api
      .placeHoldOnCard(payload)
      .then(response => {
        const res = response.data;
        if (res.status_code === 200) {
          const encryptedData = window.btoa(JSON.stringify(res.data));

          localStorage.setItem("ongoingAppointment", encryptedData);

          cb();
        } else {
          errorHandler(res.message[0]);
          dispatch(apiSuccess());
        }
      })
      .catch(error => {
        catchHandler(error, dispatch);
      });
  };
};

export const captureHoldAmount = (amount, cb = () => {}) => {
  return (dispatch, getState) => {
    dispatch(apiStart());

    const paymentInfo = JSON.parse(
      window.atob(localStorage.getItem("ongoingAppointment"))
    );

    const appointmentData =
      getState()?.dashboard?.ongoingAppointment?.currentAppointment
        ?.patient_detail?.id ||
      getState()?.dashboard?.ongoingAppointment?.currentAppointment?.patient
        ?.id;

    const payload = {
      payment_intent_id: paymentInfo?.id,
      amount: amount,
      patient_detail: appointmentData,
    };

    api
      .captureHoldAmount(payload)
      .then(response => {
        const res = response.data;
        if (res.status_code === 200) {
          if (res?.data?.status === "succeeded")
            successHandler(`Payment received $${amount}`);

          if (
            res?.data?.status === "requires_action" ||
            res?.data?.status === "requires_action"
          )
            successHandler(`Waiting for Payment Confirmation!
            `);
          cb();
        } else {
          errorHandler(res.message[0]);
        }
        localStorage.removeItem("ongoingAppointment");
        dispatch(apiSuccess());
      })
      .catch(error => {
        catchHandler(error, dispatch);
      });
  };
};
